export const SEAT_STATUS = {
  AVAILABLE: 'available',
  OCCUPIED: 'occupied'
}
